module.exports = __webpack_public_path__ + "img/manager.13b5fec4.png";